'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));
var _Input = _interopRequireDefault(require("@mui/material/Input"));
var _NativeSelect = _interopRequireDefault(require("@mui/material/NativeSelect"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
let app = window.app;
class WrappedSelect extends _react.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "handleChange", e => {
      const component = this,
        props = this.props;
      let value = e.target.value;
      props.onChange({
        e: e,
        value: value,
        name: props.name,
        source: 'native'
      });
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: props['default-value'] || '',
      name: props.name,
      source: 'DidMount'
    });
  }
  render() {
    const component = this,
      props = this.props;
    let error_msg,
      status = props.status[props.name] || {};
    let class_name = props.className;
    const id = String(++app.form_index);
    if (props['full-width']) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    class_name += ' mui-select';
    if (status && status.error) {
      error_msg = /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, status.error);
    }
    const options = props.getOptions().map(function (option, key) {
      let output = /*#__PURE__*/_react.default.createElement("option", {
        value: option.value,
        key: key
      }, option.label || option.value || '');
      return output;
    });
    let styles = _objectSpread({}, props.style);
    if (props['no-margin']) {
      styles = {
        formControl: {
          marginTop: 0
        }
      };
    }
    const no_value_option = props['no-value-option'] ? /*#__PURE__*/_react.default.createElement("option", {
      value: "",
      style: {
        display: 'none'
      }
    }) : undefined;
    const label = props.label ? /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
      htmlFor: id
    }, props.label) : undefined;
    const value = typeof props.value === 'undefined' ? props['default-value'] : props.value;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: class_name,
      style: props.style
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      fullWidth: props['full-width'],
      error: Boolean(status.error),
      style: styles,
      variant: "standard"
    }, label, /*#__PURE__*/_react.default.createElement(_NativeSelect.default, {
      id: id,
      onChange: component.handleChange,
      value: value,
      name: props.name,
      required: props.required,
      input: /*#__PURE__*/_react.default.createElement(_Input.default, null),
      disabled: props['read-only'] === true
    }, no_value_option, options), error_msg));
    return output;
  }
}
WrappedSelect.propTypes = {
  'no-value-option': _propTypes.default.bool,
  'full-width': _propTypes.default.bool,
  'no-margin': _propTypes.default.bool,
  required: _propTypes.default.bool,
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  'default-value': _propTypes.default.string,
  value: _propTypes.default.string,
  status: _propTypes.default.object.isRequired,
  style: _propTypes.default.object,
  onChange: _propTypes.default.func.isRequired
};
WrappedSelect.defaultProps = {
  'no-value-option': true,
  'full-width': true,
  'no-margin': false,
  required: false,
  'default-value': '',
  className: '',
  style: {}
};
class SelectStore extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "retrieveOptions", () => {
      return this.options;
    });
  }
  render() {
    this.options = this.props.options;
    return /*#__PURE__*/_react.default.createElement(WrappedSelect, (0, _extends2.default)({}, this.props, {
      options: undefined,
      getOptions: this.retrieveOptions
    }));
  }
}
exports.default = SelectStore;
SelectStore.propTypes = {
  options: _propTypes.default.array.isRequired
};
